import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var PAGINATION_WIDTH = 7;
export function preparePagination(options) {
  var totalPages = options.totalPages,
    currentPage = options.currentPage;
  // если общее количеств страниц не больше кол-ва элементов в блоке PAGINATION_WIDTH, выводим все
  if (totalPages <= PAGINATION_WIDTH) {
    return Array.from({
      length: totalPages
    }, function (_, index) {
      return preparePage(_objectSpread({
        page: index + 1
      }, options));
    });
  }
  var pagination = [];
  var endPage = Math.min(Math.max(PAGINATION_WIDTH, currentPage + 3), totalPages);
  var startPage = endPage - 5;

  // В блоке пагинации всегда отображаем 1 страницу
  // [1] [startPage] [ ] [ ] [ ] [ ] [endPage]
  pagination.push(preparePage(_objectSpread({
    page: 1
  }, options)));
  var mainRange = Array.from({
    length: endPage - startPage + 1
  }, function (_, index) {
    return startPage + index;
  });
  mainRange.forEach(function (page, index) {
    var title;
    if (index === 0 && page > 2 || index === mainRange.length - 1 && page < totalPages) {
      title = '...';
    }
    pagination.push(preparePage(_objectSpread({
      page: page,
      title: title
    }, options)));
  });
  return pagination;
}
function preparePage(_ref) {
  var page = _ref.page,
    currentPage = _ref.currentPage,
    title = _ref.title;
  return {
    page: page,
    disabled: page === currentPage,
    title: title || page.toString()
  };
}